var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExplanation3 = function SvgExplanation3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 362,
    viewBox: "0 0 397 362",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M390.368 134.638H126.784C126.647 134.765 126.529 134.892 126.393 135.01C113.934 146.28 98.0797 151.047 82.4609 156.359H394.581C393.635 149.037 392.228 141.783 390.368 134.638Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M396.199 178.652H43.1343C37.3718 185.026 32.7847 192.371 29.5859 200.346H395.364C396.009 193.133 396.288 185.893 396.199 178.652Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M22.147 244.36H387.189C389.217 237.229 390.921 229.994 392.302 222.657H23.4547C22.3162 229.832 21.8782 237.1 22.147 244.36Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M31.156 284.578C31.7009 285.859 32.282 287.121 32.8814 288.365H369.211C372.993 281.94 376.275 275.234 379.027 268.306C379.245 267.761 379.454 267.216 379.662 266.671H25.1719C26.6473 272.801 28.6495 278.793 31.156 284.578Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M70.7214 332.379H327.186C336.61 326.262 345.215 318.969 352.794 310.676H47.0391C53.8853 318.977 61.8562 326.282 70.7214 332.379Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.402 360.556C235.808 359.687 255.118 357.334 274.164 353.519C288.567 350.675 302.499 345.824 315.554 339.108V261.15H216.402V360.556Z",
    fill: "#94E0B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216.402 360.556C235.808 359.687 255.118 357.334 274.164 353.519C288.567 350.675 302.499 345.824 315.554 339.108V261.15H216.402V360.556Z",
    fill: "black",
    fillOpacity: 0.5,
    stroke: "#253838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M216.402 360.557V261.151L207.82 240.81V360.865C210.69 360.793 213.568 360.675 216.402 360.557Z",
    fill: "#253838"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M315.59 261.313H216.429L207.82 240.8H306.972L315.59 261.313Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M315.59 261.313H216.429L207.82 240.8H306.972L315.59 261.313Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210.363 315.271H111.211V351.058C114.238 351.906 117.307 352.654 120.419 353.301C149.988 359.308 180.162 361.814 210.317 360.766L210.363 315.271Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M210.363 315.453H111.211L102.594 294.94H201.755L210.363 315.453Z",
    fill: "#94E0B3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M210.363 315.453H111.211L102.594 294.94H201.755L210.363 315.453Z",
    fill: "white",
    stroke: "#253838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M210.363 315.453H111.211L102.594 294.94H201.754L210.363 315.453Z",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.594 348.416C105.427 349.397 108.305 350.278 111.211 351.086V315.272L102.594 294.913V348.416Z",
    fill: "#253838"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1561 284.579C44.7226 316.179 71.7194 338.036 103.801 348.87V282.908H30.4297C30.6658 283.489 30.8746 284.025 31.1561 284.579Z",
    fill: "#94E0B3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1561 284.579C44.7226 316.179 71.7194 338.036 103.801 348.87V282.908H30.4297C30.6658 283.489 30.8746 284.025 31.1561 284.579Z",
    fill: "black",
    fillOpacity: 0.5,
    stroke: "#253838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5028 283.071H103.802L95.2206 262.603H24.2734C25.6837 269.611 27.7699 276.466 30.5028 283.071Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M361.057 110.612L310.605 50.6068L305.302 55.9099L323.69 77.7761L147.743 225.718L107.153 179.679C106.133 178.522 104.874 177.601 103.463 176.98C102.051 176.359 100.521 176.053 98.9792 176.083C97.4374 176.113 95.9206 176.479 94.5345 177.155C93.1484 177.831 91.9262 178.801 90.953 179.997L1 290.481L17.4814 303.903L99.5069 203.107L138.672 247.53C140.505 249.612 143.08 250.894 145.847 251.101C148.613 251.308 151.351 250.424 153.473 248.638L337.366 94.0396L355.754 115.915L361.057 110.612Z",
    fill: "white",
    stroke: "#253838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M387.792 36.9308L310.606 50.6063L329.004 72.4816L153.048 220.424L112.458 174.376C111.437 173.218 110.177 172.297 108.765 171.676C107.353 171.055 105.822 170.749 104.279 170.779C102.737 170.809 101.219 171.175 99.8325 171.851C98.4457 172.527 97.2227 173.497 96.2486 174.693L6.30469 285.187L22.777 298.599L104.812 197.804L143.976 242.226C145.81 244.308 148.385 245.59 151.151 245.797C153.918 246.004 156.655 245.12 158.778 243.334L342.67 88.745L361.059 110.611L387.792 36.9308Z",
    fill: "#253838",
    stroke: "#253838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M262.839 257.554C283.492 257.554 300.234 254.655 300.234 251.079C300.234 247.503 283.492 244.605 262.839 244.605C242.187 244.605 225.445 247.503 225.445 251.079C225.445 254.655 242.187 257.554 262.839 257.554Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M239.915 238.575C239.915 238.575 233.903 247.783 234.257 250.262C234.611 252.741 241.331 255.574 243.456 256.618C245.581 257.663 259.038 259.097 260.809 256.973C262.58 254.848 258.33 254.139 255.851 253.077C253.372 252.015 246.997 246.721 246.997 246.721L246.289 240.7L239.915 238.575Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M260.805 256.992C261.359 256.329 261.323 255.802 260.942 255.357C256.892 255.748 250.699 256.102 246.285 255.221C241.128 254.195 236.551 250.726 234.435 248.919C234.285 249.35 234.223 249.807 234.254 250.263C234.608 252.742 241.327 255.575 243.452 256.619C245.577 257.664 259.08 259.117 260.805 256.992Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M276.745 231.847C276.745 231.847 270.389 238.93 271.787 241.055C273.185 243.18 277.807 242.471 280.641 244.95C283.474 247.429 287.724 250.617 291.973 252.033C296.223 253.45 299.764 250.971 297.994 249.554C296.223 248.138 288.078 241.055 287.369 238.576C286.901 236.489 286.663 234.358 286.661 232.219L276.745 231.847Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M298.22 251.061C296.362 251.182 294.496 251.032 292.681 250.616C289.494 249.908 285.244 245.304 280.994 242.117C278.352 240.137 274.347 239.665 271.687 239.583C271.603 239.823 271.569 240.076 271.586 240.329C271.604 240.582 271.672 240.829 271.787 241.054C273.203 243.179 277.807 242.471 280.64 244.95C283.473 247.429 287.723 250.616 291.973 252.033C294.879 253.004 297.458 252.151 298.22 251.061Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M259.419 120.945C259.419 120.945 254.316 139.379 255.378 144.691C256.441 150.003 263.642 193.954 263.642 193.954L239.914 238.567L248.768 243.525C248.768 243.525 279.933 202.807 280.287 197.849C280.641 192.891 281.485 154.426 281.485 154.426L301.89 191.121L275.329 231.484C275.329 231.484 279.578 235.026 282.412 235.026H287.015C287.015 235.026 320.659 193.255 321.013 190.766C321.368 188.278 298.384 138.035 298.384 138.035L296.95 126.612L259.419 120.945Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M266.427 133.703C266.427 133.703 268.997 139.878 266.681 143.229C264.366 146.58 259.734 147.86 259.734 147.86",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M281.484 154.434L293.453 143.746",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M289.863 135.52L287.965 139.579C287.965 139.579 293.114 140.932 290.953 143.374C288.792 145.817 287.43 146.099 287.43 146.099",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M282.383 154.298L291.654 148.631",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M259.989 133.703C259.338 137.882 258.907 142.092 258.699 146.316",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M245.996 236.723L244.543 239.238",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M259.735 151.466C259.735 151.466 265.392 191.62 265.91 192.91C266.427 194.199 268.48 194.199 267.971 195.225C267.453 195.999 266.743 196.625 265.91 197.041L267.199 199.875L248.066 233.146",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M282.811 228.796L280.586 232.292",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M284.445 154.035C284.445 154.035 301.953 183.602 304.486 188.015C307.02 192.428 310.661 190.33 309.635 191.874C308.609 193.418 304.741 194.199 304.741 194.199L284.872 225.545",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M257.785 128.764C258.406 129.206 259.066 129.592 259.756 129.917C262.58 131.325 263.76 132.033 263.76 132.033L264.668 127.329L268.201 128.028L267.728 132.033C267.728 132.033 267.256 132.941 271.969 133.213C276.682 133.486 278.153 134.385 278.153 134.385L279.061 128.936L282.594 128.7V134.821C285.346 134.824 288.096 134.666 290.83 134.348C292.596 134.1 294.284 133.457 295.77 132.469V128.228L293.854 126.112L259.42 120.945C259.42 120.945 258.657 125.104 257.785 128.764Z",
    fill: "#253838"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M287.758 131.088V134.385C289.85 134.179 291.906 133.706 293.878 132.977L294.341 130.153C294.341 130.153 288.929 130.616 287.758 131.088Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M320.077 130.398L314.583 130.861L310.352 135.883C310.352 135.883 314.429 139.17 316.626 141.213C318.824 143.256 320.704 145.127 322.429 144.654C324.154 144.182 330.102 136.037 330.102 134.157C330.102 132.277 323.364 128.827 320.077 130.398Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M316.781 131.959C317.748 130.92 318.858 130.024 320.078 129.299C320.962 128.784 321.973 128.526 322.996 128.553C324.019 128.58 325.015 128.892 325.871 129.453C327.914 130.706 328.223 131.959 327.124 133.367C326.025 134.774 321.803 139.796 321.485 138.543C321.167 137.29 323.056 133.367 323.056 133.367C323.056 133.367 320.541 139.169 317.099 135.41",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M316.781 131.959C317.748 130.92 318.858 130.024 320.078 129.299C320.962 128.784 321.973 128.526 322.996 128.553C324.019 128.58 325.015 128.892 325.871 129.453C327.914 130.706 328.223 131.959 327.124 133.367C326.025 134.774 321.803 139.796 321.485 138.543C321.167 137.29 323.056 133.367 323.056 133.367C323.056 133.367 320.541 139.169 317.099 135.41",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M321.33 143.402C321.33 143.402 318.824 141.05 318.824 139.96C318.824 138.87 322.111 136.037 322.111 136.037",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M313.331 127.882L316.473 130.397L311.297 136.508L308.473 133.839L313.331 127.882Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M297.818 113.571L314.581 127.81L307.625 134.766L293.387 125.276L297.818 113.571Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M273.613 59.5687C273.613 59.5687 265.44 63.9365 264.114 71.1556C262.788 78.3747 258.793 119.074 258.793 122.679C258.793 126.284 269.045 130.661 277.971 130.852C286.898 131.043 296.015 130.852 297.349 127.81C298.684 124.768 301.345 90.1523 300.201 80.2726C299.057 70.3928 296.568 64.89 292.936 62.42C289.304 59.9501 278.562 56.7265 273.613 59.5687Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M262.387 122.761C262.387 122.761 282.764 114.679 290.836 103.792",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M260.98 125.176C269.541 126.047 278.187 124.967 286.27 122.016",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M276.652 42.098C276.652 42.098 276.652 42.4521 276.707 43.0605C276.858 46.1586 276.779 49.2637 276.471 52.3501L275.898 57.4806L290.328 61.6577C290.328 61.6577 290.9 58.6248 292.235 54.257C293.245 51.2072 294.581 48.2753 296.221 45.5123C296.221 45.5123 289.574 43.4238 285.769 40.2001C281.964 36.9765 277.987 38.1116 276.652 42.098Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M290.708 15.3187C290.708 15.3187 294.885 12.086 292.424 5.82032C289.964 -0.445328 279.503 0.308367 275.707 2.969C271.911 5.62963 273.809 7.33679 275.898 7.50933C277.986 7.68186 278.931 9.97926 276.279 10.742C273.627 11.5048 270.576 9.59787 266.209 14.3743C261.841 19.1507 266.018 23.3006 266.781 22.1655C267.543 21.0304 268.869 18.3607 269.251 20.077C269.632 21.7932 265.437 24.0543 264.883 29.3755C264.329 34.6968 269.251 40.009 272.474 42.6696C275.698 45.3303 279.884 46.084 281.782 43.5777C283.68 41.0714 285.587 36.9307 287.675 34.27C289.764 31.6094 287.294 25.1894 286.531 22.6831C285.768 20.1768 290.708 15.3187 290.708 15.3187Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M281.212 37.1573C281.212 37.1573 278.56 33.1708 276.09 34.4966C273.62 35.8224 276.09 41.3344 278.37 43.0506C280.649 44.7668 283.682 42.1425 283.682 42.1425C283.682 42.1425 288.222 48.5989 291.664 48.5989C295.105 48.5989 305.53 48.0268 306.284 44.6125C307.037 41.1981 301.534 29.9835 301.534 29.9835C301.534 29.9835 303.251 27.895 303.06 26.5692C302.869 25.2434 299.255 25.8064 298.52 25.2343C297.784 24.6623 295.859 19.7315 293.58 17.0618C291.301 14.392 290.165 14.4011 290.165 14.4011C290.165 14.4011 278.152 20.4398 280.876 22.3467C283.6 24.2536 284.508 22.5374 284.29 23.8632C284.072 25.1889 279.922 30.1288 280.658 30.7009C281.394 31.273 284.072 32.7895 283.691 34.4966C283.31 36.2038 283.491 37.7293 281.212 37.1573Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M296.701 25.6711C297.155 26.7699 297.146 27.8142 296.701 28.014C296.256 28.2137 295.476 27.4873 295.012 26.3976C294.549 25.3079 294.567 24.2546 295.012 24.0548C295.457 23.855 296.238 24.5815 296.701 25.6711Z",
    fill: "#253838"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M295.04 21.8838C295.04 21.8838 292.243 21.0575 291.09 23.2005",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M301.471 34.9053C301.471 34.9053 300.155 36.3854 298.012 35.0687",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M247.188 85.0856C247.188 85.0856 227.773 85.1855 223.796 85.8393C219.819 86.4931 224.086 97.0357 224.495 99.5238C224.904 102.012 247.188 85.0856 247.188 85.0856Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M288.783 63.9999C290.774 66.4401 292.084 69.3629 292.581 72.4725C293.079 75.582 292.746 78.7677 291.616 81.7072C287.721 91.9683 265.409 110.384 253.369 118.883C245.538 124.337 237.381 129.304 228.942 133.757C228.942 133.757 215.493 122.761 211.588 112.509C207.684 102.257 212.633 97.0717 226.799 92.1318C240.964 87.1919 259.035 80.9989 262.213 72.1543C265.391 63.3098 269.369 56.6446 275.889 57.4891C282.408 58.3336 288.783 63.9999 288.783 63.9999Z",
    fill: "#94E0B3",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M262.933 111.447C262.933 111.447 249.83 116.405 238.497 119.946C227.165 123.488 213.008 122.779 213.362 125.613C213.716 128.446 221.861 133.785 223.632 134.82C225.403 135.856 228.944 133.404 233.194 132.341C237.444 131.279 257.267 118.53 262.933 111.447Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M219.753 143.537L218.363 154.77L220.606 155.051L221.759 145.744L240.702 148.086L239.558 157.394L241.8 157.676L243.19 146.443L219.753 143.537Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M253.693 156.531L206.829 150.851C204.47 150.565 202.327 152.245 202.041 154.603L197.991 188.018C197.705 190.377 199.385 192.52 201.743 192.806L248.607 198.487C250.966 198.773 253.109 197.093 253.395 194.734L257.445 161.319C257.731 158.961 256.051 156.817 253.693 156.531Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.1667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M202.074 172.359L253.108 178.888",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M208.295 153.463L204.199 187.325L207.087 192.619L211.182 188.524L215.523 154.317",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M208.295 153.463L204.199 187.325L207.087 192.619L211.182 188.524L215.523 154.317",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M213.865 177.4L203.836 176.076L203.205 180.856L213.234 182.18L213.865 177.4Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M213.503 178.655L203.488 177.34L203.331 178.536L213.346 179.851L213.503 178.655Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16816,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M243.973 158.094L239.859 191.901L242.747 197.204L246.842 193.1L251.183 158.893",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M243.973 158.094L239.859 191.901L242.747 197.204L246.842 193.1L251.183 158.893",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M249.525 181.973L239.496 180.649L238.865 185.429L248.894 186.753L249.525 181.973Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M249.291 183.764L239.262 182.44L239.104 183.638L249.133 184.962L249.291 183.764Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M282.765 67.1876C282.765 67.1876 278.87 65.0627 272.495 65.771C266.12 66.4793 234.61 85.6032 230.025 87.728C225.439 89.8529 225.775 96.2185 225.775 96.2185L228.608 136.945H237.453L243.119 97.2809C243.119 97.2809 283.701 86.5112 284.972 78.4839",
    fill: "#94E0B3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M282.765 67.1876C282.765 67.1876 278.87 65.0627 272.495 65.771C266.12 66.4793 234.61 85.6032 230.025 87.728C225.439 89.8529 225.775 96.2185 225.775 96.2185L228.608 136.945H237.453L243.119 97.2809C243.119 97.2809 283.701 86.5112 284.972 78.4839",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M237.435 136.945L239.56 144.382C239.56 144.382 239.56 151.465 238.498 152.174C237.435 152.882 237.081 154.298 235.32 152.882L233.549 151.465C232.27 151.132 230.968 150.895 229.653 150.757C228.591 150.757 226.466 150.757 225.758 148.941C225.049 147.125 228.591 136.9 228.591 136.9L237.435 136.945Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M291.136 67.0053L292.617 73.5433C289.197 74.7169 285.607 75.3153 281.992 75.314C275.972 75.314 265.702 65.7521 258.628 60.4399C251.554 55.1277 244.462 62.2107 238.087 64.3355C231.713 66.4604 226.755 65.398 216.839 61.8565C206.922 58.3151 195.953 66.4604 195.953 66.4604L192.793 74.2516L202.709 79.5638C202.709 79.5638 211.917 69.2936 218.646 69.2936C225.374 69.2936 238.478 74.2516 243.436 71.4185C248.394 68.5853 252.289 63.2459 255.831 63.9814C259.372 64.7169 274.909 80.2721 282.691 80.9895C284.838 81.2531 287.016 80.8922 288.963 79.95C290.91 79.0079 292.544 77.5244 293.67 75.6773L296.503 67.5047C296.503 67.5047 291.772 60.8122 291.136 67.0053Z",
    fill: "#253838",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M292.8 61.2764L296.414 61.6578L301.536 70.584L296.223 66.5976L292.982 67.9234L292.609 64.8905L292.8 61.2764Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M273.157 51.3774L293.752 59.7589L293.37 68.4945L270.496 57.4615L273.157 51.3774Z",
    fill: "white",
    stroke: "#253838",
    strokeWidth: 1.16992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExplanation3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/explanation-3.8c13e101.svg";
export { ForwardRef as ReactComponent };